import React, { useState, useRef, useEffect } from 'react';
import { LogOut, Settings, ChevronDown } from 'lucide-react';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import CalendlyModal from './CalendlyModal';
import './ProfileMenu.css';

const DEFAULT_PROFILE_IMAGE = "https://firebasestorage.googleapis.com/v0/b/ugc3-846c7.firebasestorage.app/o/default-profile.png%2Fopenart-image_xvyM7zue_1747323721635_raw.png?alt=media&token=37894604-c3f7-40f2-84c8-c84cac45f8ea";

function ProfileMenu({ setActiveTab, userData }) {
  const profileImage = userData?.profileImage || DEFAULT_PROFILE_IMAGE;
  const [isOpen, setIsOpen] = useState(false);
  const [showCalendlyModal, setShowCalendlyModal] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/signin');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleSettings = (e) => {
    e.preventDefault();
    if (setActiveTab) setActiveTab('settings');
    setIsOpen(false);
  };

  const handleProfileClick = (e) => {
    e.preventDefault();
    if (setActiveTab) setActiveTab('settings');
    setIsOpen(false);
  };

  return (
    <div className="profile-wrapper" ref={menuRef}>
      <div className="profile-trigger" onClick={() => setIsOpen(!isOpen)} style={{ cursor: 'pointer' }}>
        <img
          src={profileImage || DEFAULT_PROFILE_IMAGE}
          alt="User"
          className="profile-img"
        />
        <ChevronDown size={16} className={`dropdown-arrow ${isOpen ? 'open' : ''}`} />
      </div>
      {isOpen && (
        <div className="profile-dropdown">
          <div className="profile-dropdown-header" onClick={handleProfileClick} style={{ cursor: 'pointer' }}>
            <img
              src={profileImage || DEFAULT_PROFILE_IMAGE}
              alt="User"
              className="profile-img-large"
            />
            <div className="profile-info">
              <span className="profile-name">Profile</span>
              <span className="profile-email">{userData?.brandName || auth.currentUser?.email}</span>
            </div>
          </div>
          <div className="profile-dropdown-divider" />
          <button onClick={handleSettings} className="profile-dropdown-item">
            <Settings size={16} />
            <span>Settings</span>
          </button>
          <div className="profile-dropdown-divider" />
          <button
            className="profile-dropdown-item"
            onClick={() => {
              setIsOpen(false);
              setShowCalendlyModal(true);
            }}
          >
            📞 Get Support / Book a Call
          </button>
          <div className="profile-dropdown-divider" />
          <button onClick={handleLogout} className="profile-dropdown-item">
            <LogOut size={16} />
            <span>Logout</span>
          </button>
        </div>
      )}
      <CalendlyModal 
        isOpen={showCalendlyModal} 
        onClose={() => setShowCalendlyModal(false)} 
      />
    </div>
  );
}

export default ProfileMenu;
